export const assetsPath = "assets/";
var imgsPath = assetsPath + "img/";
export const audioPath = assetsPath + "audio/";

export const to_load = {
    'coin_sprite'				: 'framework/assets/img/coin/coins_{q}.png',
    'win_font_bg'				: imgsPath + 'fonts/win_font_bg_{q}.png',

    'background' : imgsPath + "reels/background_{q}.png",

    'logo_reels' : imgsPath + "reels/logo_reels_{q}.png",

    'bonus_bg' : imgsPath + "mystery/bonus_BG_{q}.png",

    'bonus_wheel' : imgsPath + "mystery/anims/wheel_sprite_{q}.png",

    'bonus_shot' : imgsPath + "mystery/anims/shot_sprite_{q}.png",

    'bonus_flash' : imgsPath + "mystery/bonus_Flash_{q}.png",

    'bonus_colt' : imgsPath + "mystery/anims/colt_sprite_{q}.png",

    'bonus_paper' : imgsPath + "mystery/bonus_Paper_{q}.png",

    'button_FIRE_press' 	: imgsPath + "mystery/button_FIRE_press_{q}.png",
    'button_FIRE_disabled' 	: imgsPath + "mystery/button_FIRE_disabled_{q}.png",
    'button_FIRE_basic' 	: imgsPath + "mystery/button_FIRE_basic_{q}.png",

    'reels_cover' 			: imgsPath + "reels/reels_cover_{q}.png",

    'table_free-spins' 		: imgsPath + "reels/table_free-spins_{q}.png",

    "freespin_Reels-1" 		: imgsPath + "reels/freespin/freespin_Reels-1_{q}.png",
    "freespin_Reels-2" 		: imgsPath + "reels/freespin/freespin_Reels-2_{q}.png",
    "freespin_Reels-3" 		: imgsPath + "reels/freespin/freespin_Reels-3_{q}.png",
    "freespin_Reels-4" 		: imgsPath + "reels/freespin/freespin_Reels-4_{q}.png",
    "freespin_Reels-5" 		: imgsPath + "reels/freespin/freespin_Reels-5_{q}.png",

    "big_win_dynamite"			: imgsPath + "bigwin/big_win_dynamite_{q}.png",
    "big_win_dynamite_shadow"	: imgsPath + "bigwin/big_win_dynamite_shadow_{q}.png",
    "spark_sprite"				: imgsPath + "bigwin/spark_sprite_{q}.png",

    "dira1" 				: imgsPath + "reels/dira1_{q}.png",
    "dira1_ohen" 			: imgsPath + "reels/dira1_ohen_{q}.png",

    "dira2" 				: imgsPath + "reels/dira2_{q}.png",
    "dira2_ohen" 			: imgsPath + "reels/dira2_ohen_{q}.png",

    "dira3" 				: imgsPath + "reels/dira3_{q}.png",
    "dira3_ohen" 			: imgsPath + "reels/dira3_ohen_{q}.png",

    "dust" 					: imgsPath + "reels/dust_{q}.png",

    "winline_01" 			: imgsPath + "reels/winlines/winline_01_{q}.png",
    "winline_02" 			: imgsPath + "reels/winlines/winline_02_{q}.png",
    "winline_03" 			: imgsPath + "reels/winlines/winline_03_{q}.png",
    "winline_04" 			: imgsPath + "reels/winlines/winline_04_{q}.png",
    "winline_05" 			: imgsPath + "reels/winlines/winline_05_{q}.png",
    "winline_06" 			: imgsPath + "reels/winlines/winline_06_{q}.png",
    "winline_07" 			: imgsPath + "reels/winlines/winline_07_{q}.png",
    "winline_08" 			: imgsPath + "reels/winlines/winline_08_{q}.png",
    "winline_09" 			: imgsPath + "reels/winlines/winline_09_{q}.png",
    "winline_10" 			: imgsPath + "reels/winlines/winline_10_{q}.png",

    'settings_background_1'	: imgsPath + 'infos/settings_background_1_{q}.png',
    'settings_background_2'	: imgsPath + 'infos/settings_background_2_{q}.png',
    'settings_background_3'	: imgsPath + 'infos/settings_background_3_{q}.png',
    'settings_background_4'	: imgsPath + 'infos/settings_background_4_{q}.png',
    'settings_background_5'	: imgsPath + 'infos/settings_background_5_{q}.png',

    //'wintable_text_bonus'	: imgsPath + 'infos/wintable_text_bonus_{l}_{q}.png',

    "winline_01_l" 			: imgsPath + "reels/Winline_01_l_{q}.png",
    "winline_01_r" 			: imgsPath + "reels/Winline_01_r_{q}.png",
    "winline_02_l" 			: imgsPath + "reels/Winline_02_l_{q}.png",
    "winline_02_r" 			: imgsPath + "reels/Winline_02_r_{q}.png",
    "winline_03_l" 			: imgsPath + "reels/Winline_03_l_{q}.png",
    "winline_03_r" 			: imgsPath + "reels/Winline_03_r_{q}.png",
    "winline_04_l" 			: imgsPath + "reels/Winline_04_l_{q}.png",
    "winline_04_r" 			: imgsPath + "reels/Winline_04_r_{q}.png",
    "winline_05_l" 			: imgsPath + "reels/Winline_05_l_{q}.png",
    "winline_05_r" 			: imgsPath + "reels/Winline_05_r_{q}.png",
    "winline_06_l" 			: imgsPath + "reels/Winline_06_l_{q}.png",
    "winline_06_r" 			: imgsPath + "reels/Winline_06_r_{q}.png",
    "winline_07_l" 			: imgsPath + "reels/Winline_07_l_{q}.png",
    "winline_07_r" 			: imgsPath + "reels/Winline_07_r_{q}.png",
    "winline_08_l" 			: imgsPath + "reels/Winline_08_l_{q}.png",
    "winline_08_r" 			: imgsPath + "reels/Winline_08_r_{q}.png",
    "winline_09_l" 			: imgsPath + "reels/Winline_09_l_{q}.png",
    "winline_09_r" 			: imgsPath + "reels/Winline_09_r_{q}.png",
    "winline_10_l" 			: imgsPath + "reels/Winline_10_l_{q}.png",
    "winline_10_r" 			: imgsPath + "reels/Winline_10_r_{q}.png",

    "bonus_Winfont_Big"		: imgsPath + "mystery/bonus_Winfont_Big_{q}.png",

    "big-win_Start"			: imgsPath + "bigwin/big-win_Start_sprite_{q}.png",
    "big-win_Money"			: imgsPath + "bigwin/big-win_Money_{q}.png",
    "big-win_Paper" 		: imgsPath + "bigwin/big-win_Paper_{q}.png",
    "big-win_Text-1" 		: imgsPath + "bigwin/big-win_Text-1_{q}.png",

    "freespin_win_text" 	: imgsPath + "reels/freespin/freespin_win_text_{q}.png",
    "x2" 					: imgsPath + "reels/freespin/x2_{q}.png",

    "bonus_Intro" 			: imgsPath + "mystery/anims/intro_sprite_{q}.png",

    "bonus_Win-X" 			: imgsPath + "mystery/X_{q}.png",
    "bonus_Win-2" 			: imgsPath + "mystery/bonus_Win-2_{q}.png",
    "bonus_Win-3" 			: imgsPath + "mystery/bonus_Win-3_{q}.png",
    "bonus_Win-5" 			: imgsPath + "mystery/bonus_Win-5_{q}.png",


    'bonus_Winfont_Small' : imgsPath + 'mystery/bonus_Winfont_Small_{q}.png',

    'freespins_start' : imgsPath + 'reels/freespin/freespins_start_{q}.png',

    'dollars_particle_1' : imgsPath + 'bigwin/big_win_particle-1_{q}.png',
    'dollars_particle_2' : imgsPath + 'bigwin/big_win_particle-2_{q}.png',
};

export const to_load_json = {
    'infotext' 				: assetsPath + "info/info_{l}.json"
};

export const to_load_json_atlas = {

};

export const to_load_audio = {
    'BIG_WIN'	: audioPath + "bwin_BigWin.ogg",
    'FS_WIN'	: audioPath + "bwin_FreeSpins.ogg",
    'SL_WIN'	: audioPath + "bwin_Saloon.ogg",
    'bomb'		: audioPath + "bwin_Dynamite.ogg",

    'REEL_BG'	: audioPath + "reel_Spin.ogg",

    'REEL_STOP_1' : audioPath + "reel_Stop_1.ogg",
    'REEL_STOP_2' : audioPath + "reel_Stop_2.ogg",
    'REEL_STOP_3' : audioPath + "reel_Stop_3.ogg",
    'REEL_STOP_4' : audioPath + "reel_Stop_4.ogg",
    'REEL_STOP_5' : audioPath + "reel_Stop_5.ogg",

    'WIN_LINE_BANDITS_3'	: audioPath + "win_Bandits_3x.ogg",
    'WIN_LINE_BANDITS_4'	: audioPath + "win_Bandits_4x.ogg",
    'WIN_LINE_BANDITS_5'	: audioPath + "win_Bandits_5x.ogg",
    'WIN_LINE_CARDS_3'		: audioPath + "win_Cards_3x.ogg",
    'WIN_LINE_CARDS_4'		: audioPath + "win_Cards_4x.ogg",
    'WIN_LINE_CARDS_5'		: audioPath + "win_Cards_5x.ogg",
    'WIN_LINE_CASH_3'		: audioPath + "win_Cash_3x.ogg",
    'WIN_LINE_CASH_4'		: audioPath + "win_Cash_4x.ogg",
    'WIN_LINE_CASH_5'		: audioPath + "win_Cash_5x.ogg",
    'WIN_LINE_PISTOLS_2'	: audioPath + "win_Pistols_2x.ogg",
    'WIN_LINE_PISTOLS_3'	: audioPath + "win_Pistols_3x.ogg",
    'WIN_LINE_PISTOLS_4'	: audioPath + "win_Pistols_4x.ogg",
    'WIN_LINE_PISTOLS_5'	: audioPath + "win_Pistols_5x.ogg",
    'WIN_LINE_SALOON_3'		: audioPath + "win_Saloon_3x.ogg",
    'WIN_LINE_SALOON_4'		: audioPath + "win_Saloon_4x.ogg",
    'WIN_LINE_SALOON_5'		: audioPath + "win_Saloon_5x.ogg",
    'WIN_LINE_SCATTER_3'	: audioPath + "win_Scatter_3x.ogg",
    'WIN_LINE_SCATTER_4'	: audioPath + "win_Scatter_4x.ogg",
    'WIN_LINE_SCATTER_5'	: audioPath + "win_Scatter_5x.ogg",
    'WIN_LINE_WHISKEY_2'	: audioPath + "win_Whiskey_3x.ogg",
    'WIN_LINE_WHISKEY_3'	: audioPath + "win_Whiskey_4x.ogg",
    'WIN_LINE_WHISKEY_4'	: audioPath + "win_Whiskey_5x.ogg",
    'WIN_LINE_WHISKEY_5'	: audioPath + "win_Whiskey_2x.ogg",
    'WIN_LINE_WILD_3'		: audioPath + "win_Wild_3x.ogg",
    'WIN_LINE_WILD_4'		: audioPath + "win_Wild_4x.ogg",
    'WIN_LINE_WILD_5'		: audioPath + "win_Wild_5x.ogg",

    'bonus_FreeSpins_Counter'		: audioPath + "bonus_FreeSpins_Counter.ogg",

    'BACKGROUND'			: audioPath + "bg_Music.ogg",

    'BACKGROUND_FS'			: audioPath + "bg_FreeSpins.ogg",

    'BACKGROUND_SALOON'		: audioPath + "bg_Saloon.ogg",

    'SL_IN'			: audioPath + "bonus_Saloon_In.ogg",
    'SL_OUT'		: audioPath + "bonus_Saloon_Out.ogg",
    'SL_GUNSHOT'	: audioPath + "bonus_Saloon_Gunshot.ogg",

    'reel_search' : audioPath + "reel_Search.ogg",

    'SL_SND_1'		: audioPath + "symbol_Saloon_1.ogg",
    'SL_SND_2'		: audioPath + "symbol_Saloon_2.ogg",
    'SL_SND_3'		: audioPath + "symbol_Saloon_3.ogg",
    'SL_SND_4'		: audioPath + "symbol_Saloon_4.ogg",
    'SL_SND_5'		: audioPath + "symbol_Saloon_5.ogg",
    'SCATTER_SND'	: audioPath + "symbol_Scatter.ogg",
    'FS_whip'		: audioPath + "bonus_FreeSpins_Whip.ogg",

    'WIN_SHOT_1' : audioPath + "win_Shot_1.ogg",
    'WIN_SHOT_2' : audioPath + "win_Shot_2.ogg",
    'WIN_SHOT_3' : audioPath + "win_Shot_3.ogg",
    'WIN_SHOT_4' : audioPath + "win_Shot_4.ogg",
    'WIN_SHOT_5' : audioPath + "win_Shot_5.ogg",
    'Jackpot_sound' : assetsPath + "JokerWinBanner/Jackpot_sound.mp3",
};

export const to_load_fonts = {
    'win_font' :	{
        "img":	imgsPath + 'fonts/win_font.png',
        "xml":	imgsPath + 'fonts/win_font.xml'
    },

    'bonus' :	{
        img:	imgsPath + 'fonts/bonus.png',
        xml:	imgsPath + 'fonts/bonus.xml',
    },
    'font1-bonus-Wanted' :	{
        img:	imgsPath + 'fonts/font1-bonus-Wanted.png',
        xml:	imgsPath + 'fonts/font1-bonus-Wanted.xml',
    },
    'font2-bonus-Wanted' :	{
        img:	imgsPath + 'fonts/font2-bonus-Wanted.png',
        xml:	imgsPath + 'fonts/font2-bonus-Wanted.xml',
    },
    'font1-Wanted' :	{
        img:	imgsPath + 'fonts/font1-Wanted.png',
        xml:	imgsPath + 'fonts/font1-Wanted.xml',
    },
    'winfont' :	{
        img:	imgsPath + 'fonts/winfont.png',
        xml:	imgsPath + 'fonts/winfont.xml',
    }
};

import {madnes_audio_allow_multiple, madnes_set_audio_volume} from "../../framework/src/engine/madnes/madnes_audio";
import {server_config} from "../../framework/src/engine/madnes/madnes_variables";

export function set_sounds(server_config) {

    if(typeof server_config.volume.bigWin != "undefined")
    {
        madnes_set_audio_volume('BIG_WIN', server_config.volume.bigWin);
        madnes_set_audio_volume('FS_WIN', server_config.volume.bigWin);
        madnes_set_audio_volume('SL_WIN', server_config.volume.bigWin);
        madnes_set_audio_volume('bomb', server_config.volume.bigWin);
    }
    if(typeof server_config.volume.buttonEffect != "undefined")
    {
        madnes_set_audio_volume('button_click', server_config.volume.buttonEffect);
    }
    if(typeof server_config.volume.spin != "undefined")
    {
        madnes_set_audio_volume('REEL_BG', server_config.volume.spin);
    }
    if(typeof server_config.volume.stopReel != "undefined")
    {
        madnes_set_audio_volume('REEL_STOP_1', server_config.volume.stopReel);
        madnes_set_audio_volume('REEL_STOP_2', server_config.volume.stopReel);
        madnes_set_audio_volume('REEL_STOP_3', server_config.volume.stopReel);
        madnes_set_audio_volume('REEL_STOP_4', server_config.volume.stopReel);
        madnes_set_audio_volume('REEL_STOP_5', server_config.volume.stopReel);
    }
    if(typeof server_config.volume.winAnim != "undefined")
    {
        madnes_set_audio_volume('WIN_LINE_BANDITS_3', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_BANDITS_4', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_BANDITS_5', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_CARDS_3', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_CARDS_4', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_CARDS_5', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_CASH_3', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_CASH_4', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_CASH_5', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_PISTOLS_2', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_PISTOLS_3', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_PISTOLS_4', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_PISTOLS_5', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_SALOON_3', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_SALOON_4', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_SALOON_5', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_SCATTER_3', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_SCATTER_4', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_SCATTER_5', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_WHISKEY_2', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_WHISKEY_3', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_WHISKEY_4', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_WHISKEY_5', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_WILD_3', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_WILD_4', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_WILD_5', server_config.volume.winAnim);
    }
    if(typeof server_config.volume.winCounter != "undefined")
    {
        madnes_set_audio_volume('remittance_A', server_config.volume.winCounter);
        madnes_set_audio_volume('remittance_B', server_config.volume.winCounter);
        madnes_set_audio_volume('bonus_FreeSpins_Counter', server_config.volume.winCounter);
    }
    if(typeof server_config.background.background != "undefined")
    {
        madnes_set_audio_volume('BACKGROUND', server_config.background.background);
    }
    if(typeof server_config.background.freeSpinsBackground != "undefined")
    {
        madnes_set_audio_volume('BACKGROUND_FS', server_config.background.freeSpinsBackground);
    }
    if(typeof server_config.background.bonusGameBackground != "undefined")
    {
        madnes_set_audio_volume('BACKGROUND_SALOON', server_config.background.bonusGameBackground);
    }
    if(typeof server_config.miscSounds.miscSounds1 != "undefined")
    {
        madnes_set_audio_volume('coins_loop', server_config.miscSounds.miscSounds1);
    }
    if(typeof server_config.miscSounds.miscSounds2 != "undefined")
    {
        madnes_set_audio_volume('SL_IN', server_config.miscSounds.miscSounds2);
        madnes_set_audio_volume('SL_OUT', server_config.miscSounds.miscSounds2);
        madnes_set_audio_volume('SL_GUNSHOT', server_config.miscSounds.miscSounds2);
    }
    if(typeof server_config.miscSounds.miscSounds3 != "undefined")
    {
        madnes_set_audio_volume('reel_search', server_config.miscSounds.miscSounds3);
    }
    if(typeof server_config.miscSounds.miscSounds4 != "undefined")
    {
        madnes_set_audio_volume('SL_SND_1', server_config.miscSounds.miscSounds4);
        madnes_set_audio_volume('SL_SND_2', server_config.miscSounds.miscSounds4);
        madnes_set_audio_volume('SL_SND_3', server_config.miscSounds.miscSounds4);
        madnes_set_audio_volume('SL_SND_4', server_config.miscSounds.miscSounds4);
        madnes_set_audio_volume('SL_SND_5', server_config.miscSounds.miscSounds4);
        madnes_set_audio_volume('SCATTER_SND', server_config.miscSounds.miscSounds4);
        madnes_set_audio_volume('FS_whip', server_config.miscSounds.miscSounds4);
    }
    if(typeof server_config.miscSounds.miscSounds5 != "undefined")
    {
        madnes_set_audio_volume('WIN_SHOT_1', server_config.miscSounds.miscSounds5);
        madnes_set_audio_volume('WIN_SHOT_2', server_config.miscSounds.miscSounds5);
        madnes_set_audio_volume('WIN_SHOT_3', server_config.miscSounds.miscSounds5);
        madnes_set_audio_volume('WIN_SHOT_4', server_config.miscSounds.miscSounds5);
        madnes_set_audio_volume('WIN_SHOT_5', server_config.miscSounds.miscSounds5);
    }

    // for(var i in to_load_audio_madnes)
    // {
    //     if(typeof madnes_audio_levels[i] == "undefined")
    //     {
    //         console.log("Not set " + i);
    //     }
    // }

}